import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../common/utils/HeaderUtils';
import { noOfCountAPISchema } from '../components/utility/schema-defs';
import { TotalCountForAllEventServiceJourney } from '../components/utility/type-defs';

/**
 * @method getRegistryCountAction
 * @description api function to get the count of services/events/journeys
 * @param
 * @returns journey
 */
export const getRegistryCountAction = async () => {
  const resp = await apiWrapper.get<TotalCountForAllEventServiceJourney[]>(`${process.env.REACT_APP_API_BASE_URL}/status-count`, headersInstance());
  // Schema validation for getNoofCountAction api
  const apiResponse = noOfCountAPISchema.validate(
    resp.responseBody,
    { abortEarly: true }
  );
  if (apiResponse.error) {
    return undefined;
  }
  return resp.responseBody;
};
